import { PATHS } from '../config';
import { dynoapeAPI } from '../dynoape';
import {
    Breaches,
    CostPlan,
    EmployeesCriticalWorkMinutes,
    ShiftGeneratorResult,
} from './Models';

const getShiftGeneratorResult = async (
    departmentId: string,
    taskId: string,
): Promise<ShiftGeneratorResult> =>
    await dynoapeAPI.get(PATHS.result(departmentId, taskId));

const getCostPlan = async (
    departmentId: string,
    taskId: string,
): Promise<CostPlan> =>
    await dynoapeAPI.get(PATHS.costPlan(departmentId, taskId));

const getEmployeesCriticalWorkMinutes = async (
    departmentId: string,
    taskId: string,
): Promise<EmployeesCriticalWorkMinutes> =>
    await dynoapeAPI.get(
        PATHS.employeesCriticalWorkMinutes(departmentId, taskId),
    );

const getResultBreaches = async (
    departmentId: string,
    taskId: string,
    rules: string[],
): Promise<Breaches> =>
    await dynoapeAPI.get(PATHS.resultBreaches(departmentId, taskId, rules));

const DepartmentService = {
    getShiftGeneratorResult,
    getCostPlan,
    getEmployeesCriticalWorkMinutes,
    getResultBreaches,
};

export default DepartmentService;
